import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const UpdateAssessmentRunsMutation = graphql(`
    mutation UpdateAssessmentRuns($id: ObjectID!, $input: UpdateAssessmentRunsInput!) {
        updateAssessmentRuns(id: $id, input: $input) {
            __typename
            ... on UpdateAssessmentRunsSuccessfulResponse {
                result {
                    id
                    name
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type UpdateAssessmentRunsMutationVariables = VariablesOf<typeof UpdateAssessmentRunsMutation>;
